import { createSelector } from 'reselect';
import {
  modelToSegmentDefinitionWithDisabled,
  modelWithoutPartials,
  SearchModel,
  SegmentDefinitionWithDisabled,
} from '@fullstory/search-model';
import { TimeRange } from '@fullstory/client-api';
import { AppState } from '../../types';
import { createDeepEqualSelector } from '@fullstory/redux-util/utils/selectors';

const getSearchModel = (state: AppState) => state.search.searchModel;

export const getUIModel = (state: AppState): SearchModel => state.search.uiModel;

export const getTimeRange = (state: AppState): TimeRange => state.search.timeRange;

export const getSearchModelWithoutPartials = createSelector(getSearchModel, modelWithoutPartials);

const _getSearchSegmentDefinition = createSelector(
  getSearchModelWithoutPartials,
  getTimeRange,
  (searchModel: SearchModel, timeRange: TimeRange) => {
    const toRet = modelToSegmentDefinitionWithDisabled(searchModel);
    if (toRet) {
      if (toRet.definition.constraints) {
        toRet.definition.constraints.timeRange = {
          startTime: timeRange.Start,
          endTime: timeRange.End,
        };
      }
      if (toRet.definition.excludeConstraints) {
        toRet.definition.excludeConstraints.timeRange = {
          startTime: timeRange.Start,
          endTime: timeRange.End,
        };
      }
    }
    return toRet;
  },
);

export const getSearchSegmentDefinition = createDeepEqualSelector(
  _getSearchSegmentDefinition,
  (segmentDefinitionWithDisabled: SegmentDefinitionWithDisabled) => segmentDefinitionWithDisabled,
);

export const getPendingSuggestion = (state: AppState) => state.search.pendingSuggestion;
